<template>
  <cv-header-menu aria-label="Posizioni" title="Posizioni" v-bind:hover-toggle="autoapertura">
    <cv-header-menu-item href="/#/comuni">Comuni</cv-header-menu-item>
    <cv-header-menu-item href="/#/province">Province</cv-header-menu-item>
    <cv-header-menu-item href="/#/fondi">Fondi</cv-header-menu-item>
  </cv-header-menu>
</template>

<script>
export default {
  name: "MenuPosizioni",
  props: {
    autoapertura: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>

</style>